import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Box, TextInput } from 'grommet'
import styled from 'styled-components'

import { setTitleText as setTitleTextMain } from '../../redux/homepage/actions'
import { setTitleText as setTitleTextRIG } from '../../redux/rig/actions'
import { setTitleText as setTitleTextRTG } from '../../redux/rtg/actions'
import { setTitleText as setTitleTextYNW } from '../../redux/ynw/actions'
import { setTitleText as setTitleTextRLG } from '../../redux/rlg/actions'
import { setTitleText as setTitleTextRNG } from '../../redux/rng/actions'
import { setTitleText as setTitleTextRCG } from '../../redux/rcg/actions'
import { setTitleText as setTitleTextRDG } from '../../redux/rdg/actions'
import { setTitleText as setTitleTextICP } from '../../redux/icp/actions'
import { device } from '../../theme/device'

const TitleBox = styled(Box)`
  display: ${props => (props.titleActive ? 'flex' : 'none')};
  height: 6rem;
  border-top: .5rem double ${props =>
    props.isModal
      ? props.theme.global.colors.resultBorder
      : props.theme.global.colors.border};
  border-bottom: .5rem double ${props =>
    props.isModal
      ? props.theme.global.colors.resultBorder
      : props.theme.global.colors.border};
  margin: 0 1.5rem 1rem;
  /* position: relative; */
  /* &::before {
    content: '';
    position: absolute;
    background-color: ${props => props.theme.global.colors.line};
    height: 100%;
    width: calc(100% - 3rem);
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
  } */
`

const TitleInput = styled(TextInput)`
  font-size: ${props => (props.isModal ? '2.9rem' : '2.6rem')};
  text-align: center;
  font-weight: ${props => (props.isModal ? 700 : 600)};
  letter-spacing: 0.8px;
  ${props =>
    props.isModal &&
    `text-shadow: -1px 1px 1.5px #fff,
				  1px 1px 1.5px #fff,
				 1px -1px 0 #fff,
				-1px -1px 0 #fff;`}
  border-radius: .5rem;
  color: ${props => props.theme.global.colors.text};
  @media ${device.medium} {
    font-size: 2.6rem;
  }
  &::placeholder {
    color: ${props => props.theme.global.colors.placeholder};
  }
`

// const Dot = styled.div`
//   position: absolute;
//   background-color: ${props => props.theme.global.colors.line};
//   width: ${props => props.size};
//   height: ${props => props.size};
//   border-radius: 50%;
//   ${props => props.top && `top: ${props.top}`};
//   ${props => props.bottom && `bottom: ${props.bottom}`};
//   ${props => props.left && `left: ${props.left}`};
//   ${props => props.right && `right: ${props.right}`};
// `

// const Dot2 = styled.div`
//   position: absolute;
//   background-color: ${props => props.theme.global.colors.line};
//   width: 8px;
//   height: 8px;
//   border-radius: 50%;
//   bottom: 9px;
//   left: 9px;
// `

// const Dot3 = styled.div`
//   position: absolute;
//   background-color: ${props => props.theme.global.colors.line};
//   width: 8px;
//   height: 8px;
//   border-radius: 50%;
//   top: 9px;
//   right: 9px;
// `

// const Dot4 = styled.div`
//   position: absolute;
//   background-color: ${props => props.theme.global.colors.line};
//   width: 8px;
//   height: 8px;
//   border-radius: 50%;
//   bottom: 9px;
//   right: 9px;
// `

const setTitleText = {
  main: setTitleTextMain,
  rig: setTitleTextRIG,
  rtg: setTitleTextRTG,
  ynw: setTitleTextYNW,
  rlg: setTitleTextRLG,
  rng: setTitleTextRNG,
  rcg: setTitleTextRCG,
  rdg: setTitleTextRDG,
  icp: setTitleTextICP,
}

const Title = ({ isModal = false, page }) => {
  // const [title, setTitle] = useState('')
  const { text: titleText, active: titleActivePersist } = useSelector(
    state => state[page].title,
  )
  const [titleActive, setTitleActiveInner] = useState(false)

  useEffect(() => {
    if (titleActivePersist !== titleActive) {
      setTitleActiveInner(titleActivePersist)
    }
  }, [titleActivePersist])

  const dispatch = useDispatch()
  return (
    <TitleBox
      justify="center"
      align="center"
      alignSelf="stretch"
      isModal={isModal}
      titleActive={titleActive}
    >
      <TitleInput
        value={titleText}
        placeholder="Title: Type Here..."
        onChange={event => dispatch(setTitleText[page](event.target.value))}
        plain
        isModal={isModal}
        readOnly={isModal ? true : false}
      />
    </TitleBox>
  )
}

export default Title
